import { Button, Paper, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import axios from "../../config/authaxios";
import Dropdown from "../../css/dropdown.module.scss";
import { useStyles } from "../../theme/theme";
import { IconButton, Typography, Chip, Autocomplete, Avatar } from "@mui/material";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useNavigate } from 'react-router-dom';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Publihser() {
  const [coupons, setCoupons] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [isVerified, setIsVerified] = useState(true);
  const [isMore, setIsMore] = useState(false);
  const [nodata, setNodata] = useState(false);
  const [open, setOpen] = useState(false);
  const [isPublisherId, setIsPublisherId] = useState();
  const classes = useStyles();
  const [pageSize, setPageSize] = useState(25);
  const [mobileStatus, setMobileStatus] = useState(false);
  const [openRegister, setOpenRegister] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);
  const [openCategory, setOpenCategory] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedPublisher, setSelectedPublisherId] = useState("");
  const [categories, setCategories] = useState([
    { _id: 1, name: "Qwick Cilver" },
    { _id: 2, name: "Khiladi Adda" },
    { _id: 3, name: "Google Play" },
    { _id: 4, name: "Therewards" },
  ]);


  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    // app_key: "",
    // secret_key: "",
    password: "",
    c_password: "",
  });
  const navigate = useNavigate();

  const [changePasswordData, setChangePasswordData] = useState({
    email: "",
    password: "",
    c_password: "",
  });

  const CouponsColomns = [
    {
      field: "s_no",
      headerName: "S. No.",
      headerClassName: "super-app-theme--header",
      flex: 1,
      filterable: false,
      renderCell: (index) =>
        index.api?.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
    },
    {
      field: "_id",
      headerName: "ID",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "email",
      headerName: "Email",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
    },

    {
      field: "required_mobile",
      headerName: "Is Required Mobile",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <IconButton
            sx={{ borderRadius: 2 }}
            onClick={() => {
              setIsPublisherId(params?.row?._id);
              setMobileStatus(!params?.row?.required_mobile);
              setOpen(true);
            }}
          >
            {params?.row?.required_mobile ? (
              <Typography>True</Typography>
            ) : (
              <Typography color="primary">False</Typography>
            )}
          </IconButton>
        );
      },
    },

    {
      field: "Category",
      headerName: "Voucher Category",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            onClick={() => {
              setOpenCategory(true); setSelectedPublisherId(params?.row?._id); const selectedObjs = params?.row?.category_type?.map(id =>
                categories.find(c => c._id === id)
              ).filter(Boolean);

              setSelectedCategories(selectedObjs);
            }}
          >
            Category
          </Button>
        );
      },
    },

    {
      field: "Change Password",
      headerName: "Change Password",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            onClick={() => {
              setChangePasswordData({
                ...changePasswordData,
                email: params?.row?.email,
              });
              setOpenPassword(true);
            }}
          >
            Change Password
          </Button>
        );
      },
    },


    // {
    //     field: 'profile_no',
    //     headerName: 'Profile no.',
    //     headerClassName: 'super-app-theme--header',
    //     flex: 1,
    //     minWidth: 100,
    // },
    // {
    //     field: 'created_at',
    //     headerName: 'Created At',
    //     headerClassName: 'super-app-theme--header',
    //     flex: 1,
    //     minWidth: 200,
    // },
    // {
    //     field: 'updated_at',
    //     headerName: 'Updated At',
    //     headerClassName: 'super-app-theme--header',
    //     flex: 1,
    //     minWidth: 200,
    // },
  ];

  const fetchPublishers = () => {
    setPage(0);
    setNodata(true);
    setIsMore(false);

    axios.get(`/admin/publishers/0/10/${isVerified}/false`).then((res) => {
      if (res.data.status_code == 401) {
        localStorage.clear();
      }
      let data = res.data.response;
      if (res.data.status) {
        setCoupons(res.data.response);
        if (data && data.length < limit) {
          setIsMore(true);
        }
        if (data.length === 0) {
          setNodata(true);
        } else {
          setNodata(false);
        }
        setPage(1);
      }
    });
  };

  const verfiyHandler = async () => {
    axios
      .post(`admin/publisher/verify`, {
        profit_margin: 1,
        publisher_id: isPublisherId,
      })
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        let data = res.data.response;
        console.log(data);
        if (res.data.status) {
          alert(res.data.message);
          setOpen(false);
          setCoupons([]);
          fetchPublishers();
        }
      });
  };

  const changeMobileRequreStaus = async () => {
    axios
      .post(`/admin/changeMobileRequireStatus`, {
        publisher_id: isPublisherId,
        is_mobile: mobileStatus,
      })
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        let data = res.data.response;
        console.log(data);
        if (res.data.status) {
          alert(res.data.message);
          setOpen(false);
          setCoupons([]);
          fetchPublishers();
        }
      });
  };

  useEffect(() => {
    fetchPublishers();
    return () => {
      setCoupons([]);
    };
  }, []);

  const Showmore = () => {
    setNodata(true);
    setIsMore(false);
    let temp = "?";

    if (page === 0 || page) {
      temp += "page=" + page + "&";
    }

    if (limit) {
      temp += "limit=" + limit + "&";
    }
    axios.get(`/admin/coupons-list${temp}`).then((res) => {
      if (res.data.status_code == 401) {
        localStorage.clear();
      }
      let data = res.data.response;
      if (Object.keys(data).length === 0) {
        setNodata(false);
        setIsMore(true);
      }
      let temp = [...coupons, ...data];

      if (data.length < limit) {
        setIsMore(true);
      }
      setCoupons(temp);
      setNodata(false);
      setPage(page + 1);
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    if (
      !formData?.name ||
      !formData?.email ||
      !formData?.mobile ||
      !formData?.password ||
      !formData?.c_password
    ) {
      alert("Please Enter All Field Value");
      return;
    }

    if (formData?.password != formData?.c_password) {
      alert("Password and Confirm Password Not Matched");
      return;
    }
    setOpenRegister(false);

    axios
      .post(`/publishers/api/register`, formData)
      .then((res) => {
        console.log("res password Change", res);
        alert(res?.data?.message)
      })
      .catch((error) => {
        console.log("error in Adding publisher", error);
      });
  };

  const handleChangePassWord = () => {
    if (
      !changePasswordData?.email ||
      !changePasswordData?.password ||
      !changePasswordData?.c_password
    ) {
      alert("Please Enter All Field Value");
      return;
    }

    if (changePasswordData?.password != changePasswordData?.c_password) {
      alert("Password and Confirm Password Not Matched");
      return;
    }
    setOpenPassword(false);
    axios
      .post(`/publishers/api/handleChangePublisherPassword`, changePasswordData)
      .then((res) => {
        console.log("res for adding publisher", res);
        alert(res?.data?.message)
        setChangePasswordData({
          email: "",
          password: "",
          c_password: "",
        })
      })
      .catch((error) => {
        console.log("error in Password Changing", error);
      });

  }

  const handleSubmitCategory = (selectedCategories) => {
    const categoryIds = selectedCategories.map(cat => cat._id);
    console.log("thisis the best way----------->")
    axios.post(`/admin/add/category/to/publisher`, {
      publisher_id: selectedPublisher,
      categories_id: categoryIds,
    })
      .then((res) => {
        alert(res?.data?.message || "Categories updated successfully!");
        setOpenCategory(false);
        fetchPublishers();
      })
      .catch((err) => {
        console.error("Error updating categories:", err);
      });
  };

  const handleClose = () => {
    setOpenPassword(false);
    setChangePasswordData({
      password: "",
      c_password: "",
    })
  }
  console.log("thisishsdkfkj")
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "12px",
  };

  return (
    <>
      <section>
        <section>
          <section style={{ width: "45%" }}>
            <div className={Dropdown.dropdown}>
              {coupons.length > 0 && !isMore && (
                <Button
                  variant="contained"
                  sx={{ ml: 1, my: 2 }}
                  color="info"
                  className={Dropdown.dropbtn}
                  onClick={Showmore}
                >
                  More
                </Button>
              )}
            </div>

            <div className={Dropdown.dropdown}>
              <Button
                variant="contained"
                sx={{ ml: 1, my: 2 }}
                color="info"
                className={Dropdown.dropbtn}
              >
                limit
              </Button>
              <div className={Dropdown.dropdown_content}>
                <a
                  className={limit === 25 ? "disabled" : "notDisabled"}
                  onClick={() => {
                    setLimit(25);
                    setPage(0);
                  }}
                >
                  25
                </a>
                <a
                  disabled={limit === 50 ? true : false}
                  onClick={() => {
                    setLimit(50);
                    setPage(0);
                  }}
                >
                  50
                </a>
                <a
                  disabled={limit === 100 ? true : false}
                  onClick={() => {
                    setLimit(100);
                    setPage(0);
                  }}
                >
                  100
                </a>
                <a
                  disabled={limit === 500 ? true : false}
                  onClick={() => {
                    setLimit(500);
                    setPage(0);
                  }}
                >
                  500
                </a>
                <a
                  disabled={limit === 1000 ? true : false}
                  onClick={() => {
                    setLimit(1000);
                    setPage(0);
                  }}
                >
                  1000
                </a>
              </div>
            </div>

            {/* <div className={Dropdown.dropdown}>
              <Button
                variant="contained"
                sx={{ ml: 1, my: 2 }}
                color="info"
                className={Dropdown.dropbtn}
              >
                Verified
              </Button>
              <div className={Dropdown.dropdown_content}>
                <a
                  onClick={() => {
                    setIsVerified(true);
                  }}
                >
                  True
                </a>
                <a
                  onClick={() => {
                    setIsVerified(false);
                  }}
                >
                  False
                </a>
              </div>
            </div> */}
            <Button
              variant="contained"
              sx={{ ml: 1, my: 2 }}
              color="info"
              className={Dropdown.dropbtn}
              onClick={() => setOpenRegister(true)}
            >
              Create Publisher
            </Button>
          </section>
        </section>
        {nodata && !coupons.length == 0 && <section>Loading...</section>}

        <Paper
          sx={{
            bgcolor: "#fff",
            "& .super-app-theme--header": {
              bgcolor: "#DC8449",
              color: "#fff",
            },
          }}
          elevation={0}
        >
          {console.log("coupons-->", coupons)}
          <DataGrid
            className={classes.root}
            sx={{
              border: 0,
            }}
            hideFooterPagination
            // getRowHeight={() => 'auto'}
            autoHeight
            rows={coupons}
            columns={CouponsColomns}
            getRowId={(row) => row._id}
            disableSelectionOnClick
            disableRowSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            // pagination
            pageSize={pageSize}
            disableColumnSelector
          />
        </Paper>
      </section>

      {coupons.length > 0 && !isMore && (
        <Button
          variant="contained"
          sx={{ ml: 1, my: 2 }}
          color="info"
          onClick={Showmore}
        >
          More
        </Button>
      )}

      <Modal
        open={openPassword}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Change Password
          </Typography>

          {/* Input Fields */}
          <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Email"
              name="email"
              value={changePasswordData?.email}
              // onChange={handleChange}
              fullWidth
            />
            <TextField
              type="password"
              label="Password"
              name="password"
              value={changePasswordData?.password}
              onChange={(e) => {
                setChangePasswordData({
                  ...changePasswordData,
                  password: e?.target?.value,
                });
              }}
              fullWidth
            />

            <TextField
              type="password"
              label="Confirm Password"
              name="c_password"
              value={changePasswordData?.c_password}
              onChange={(e) => {
                setChangePasswordData({
                  ...changePasswordData,
                  c_password: e?.target?.value,
                });
              }}
              fullWidth
            />
          </Box>

          {/* Action Buttons */}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
          >
            <Button onClick={() => setOpenPassword(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleChangePassWord}>
              Change
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you Sure you want to Change Mobile Status?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button
              onClick={() => {
                changeMobileRequreStaus();
              }}
            >
              Yes
            </Button>
            <Button>No</Button>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={openRegister}
        onClose={() => setOpenRegister(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Register Publisher
          </Typography>

          {/* Input Fields */}
          <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="Mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              fullWidth
            />
            {/* <TextField
              label="App Key"
              name="app_key"
              value={formData.app_key}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="Secret Key"
              name="secret_key"
              value={formData.secret_key}
              onChange={handleChange}
              fullWidth
            /> */}
            <TextField
              type="password"
              label="Password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              type="password"
              label="Confirm Password"
              name="c_password"
              value={formData.c_password}
              onChange={handleChange}
              fullWidth
            />
          </Box>

          {/* Action Buttons */}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
          >
            <Button onClick={() => setOpenRegister(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSubmit}>
              Register
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openCategory}
        onClose={() => setOpenCategory(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Add Category
          </Typography>
          <Autocomplete
            multiple
            options={categories}
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            value={selectedCategories}
            onChange={(event, newValue) => setSelectedCategories(newValue)}
            isOptionEqualToValue={(option, value) => option._id === value._id} // 👈 important
            renderOption={(props, option) => (
              <Box component="li" sx={{ display: "flex", alignItems: "center", gap: 1 }} {...props}>
                <Avatar src={option.image} alt={option.name} sx={{ width: 30, height: 30 }} />
                {option.name}
              </Box>
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  key={option._id}
                  label={option.name}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => <TextField {...params} label="Select Categories" />}
            sx={{ mt: 2 }}
          />
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
          >
            <Button onClick={() => setOpenCategory(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => handleSubmitCategory(selectedCategories)}
            >
              Add
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default Publihser;
